import styled from "styled-components";
import {useState} from "react";
import {FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaTiktok} from "react-icons/fa";
import axios from "axios";
import {BASE_URL} from "../home/BASE_URL";
import {message} from "antd";

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);
    const [setAlertMessage] = useState(null);

    const HandleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const sendEmail = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!/\S+@\S+\.\S+/.test(formData.email)) {
            message.error("Please enter a valid email address.");
            return;
        }

        try {
            const res = await axios.post(`${BASE_URL}/sen-contact-mail-to-admin`, formData);
            if (res.data) {
                message.success("Thank you! Your message has been sent successfully.");
                setFormData({
                    name: "",
                    email: "",
                    message: "",
                });
            } else {
                console.error(res.error);
                message.error("Sorry, there was an issue sending your message.");
            }
        } catch (error) {
            console.error(error.text);
            message.error("Sorry, there was an issue sending your message.");
        } finally {
            setLoading(false);
            setTimeout(() => setAlertMessage(null), 4000);
        }
    };

    return (
        <ContactSection>
            <Container>
                <Header>
                    <Title>Get Signed. Get Heard. Get Moving.</Title>
                    <Subtitle>
                        At XTiiM, we're all about real talent, raw sound, and global impact. Reach out to us for
                        inquiries, demo submissions, collaborations, or media requests.
                    </Subtitle>
                </Header>

                <ContactDetails>
                    <Detail>
                        <h3>Contact Info</h3>
                        <p>
                            <span>Phone:</span> +234 813 246 8134
                        </p>
                        <p>
                            <span>Email:</span> xtiimmusic@gmail.com
                        </p>
                        <p>
                            <span>Studio Address:</span> ikeja Lagos
                        </p>
                    </Detail>
                    <SocialLinks>
                        <h3>Follow Us</h3>
                        <Icons>
                            {/* Facebook */}
                            <a href="https://facebook.com/xtiimmusic" target="_blank" rel="noreferrer">
                                <FaFacebook />
                            </a>

                            {/* Instagram */}
                            <a href="https://instagram.com/xtiimmusic" target="_blank" rel="noreferrer">
                                <FaInstagram />
                            </a>

                            {/* Twitter / X */}
                            <a href="https://twitter.com/xtiimmusic" target="_blank" rel="noreferrer">
                                <FaTwitter />
                            </a>

                            {/* YouTube */}
                            <a href="https://youtube.com/@xtiimmusic" target="_blank" rel="noreferrer">
                                <FaYoutube />
                            </a>

                            {/* TikTok (already working) */}
                            <a href="https://tiktok.com/@xtiimmusic" target="_blank" rel="noreferrer">
                                <FaTiktok />
                            </a>
                        </Icons>
                    </SocialLinks>
                </ContactDetails>

                <ContactForm>
                    <h3>Send Us a Message</h3>
                    <p>Use the form below to reach the XTiiM team directly.</p>
                    <Form onSubmit={sendEmail}>
                        <Input
                            type="text"
                            value={formData.name}
                            onChange={HandleChange}
                            name="name"
                            placeholder="Your Name"
                            required
                        />
                        <Input
                            type="email"
                            name="email"
                            onChange={HandleChange}
                            value={formData.email}
                            placeholder="Your Email"
                            required
                        />
                        <Textarea
                            name="message"
                            onChange={HandleChange}
                            value={formData.message}
                            placeholder="Message or Inquiry"
                            rows="6"
                            required
                        ></Textarea>
                        <Button type="submit" disabled={loading}>
                            {loading ? "Sending..." : "Send Message"}
                        </Button>
                    </Form>
                </ContactForm>

                {/* <ExtraSection> */}
                <VideoWrapper>
                    <h3>XTiiM Studio Tour</h3>
                    <div>
                        <iframe
                            width="100%"
                            height="315"
                            src="https://www.youtube.com/embed/vAdQvPlh1f4?si=aOZ6cZxLGtnc1b5w"
                            title="Xtiim Studio Tour"
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>{" "}
                        <iframe
                            width="100%"
                            height="315"
                            src="https://www.youtube.com/embed/YeVjRlY6x5U?si=BhJ3VIlcPzAhPly-"
                            title="Xtiim Studio Tour"
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                    </div>
                </VideoWrapper>
                {/* </ExtraSection> */}
            </Container>
        </ContactSection>
    );
};

export default ContactPage;

const ContactSection = styled.section`
    background: #1a1a1a;
    padding: 60px 20px;
    color: white;
`;

const Container = styled.div`
    max-width: 1200px;
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 40px;
`;

const Header = styled.div`
    text-align: center;
`;

const Title = styled.h1`
    color: rgb(0, 195, 255);
`;

const Subtitle = styled.p`
    color: #ccc;
`;

const ContactDetails = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    justify-content: space-between;
    color: #ccc;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const Detail = styled.div`
    flex: 1;

    h3 {
        color: rgb(0, 195, 255);
        margin-bottom: 10px;
    }

    span {
        color: rgb(0, 195, 255);
        margin-bottom: 10px;
    }

    p {
        line-height: 20px;
        font-size: 14px;
    }
`;

const SocialLinks = styled.div`
    flex: 1;
    h3 {
        color: rgb(0, 195, 255);
        margin-bottom: 10px;
    }
`;

const Icons = styled.div`
    display: flex;
    gap: 15px;
    font-size: 1.8rem;

    a {
        color: #ccc;
        transition: color 0.3s;
        &:hover {
            color: rgb(0, 195, 255);
        }
    }
`;

const ContactForm = styled.div`
    background: #222;
    padding: 40px;
    border-radius: 10px;

    h3 {
        color: rgb(0, 195, 255);
        margin-bottom: 10px;
    }

    p {
        color: #aaa;
        margin-bottom: 20px;
    }

    @media (max-width: 768px) {
        padding: 20px;
    }
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

const Input = styled.input`
    padding: 15px;
    background: #333;
    border: 1px solid #444;
    color: white;
    border-radius: 5px;

    &:focus {
        border: 1px solid rgb(0, 195, 255);
        transition: border 0.5s;
    }
`;

const Textarea = styled.textarea`
    padding: 15px;
    background: #333;
    border: 1px solid #444;
    color: white;
    border-radius: 5px;

    &:focus {
        border: 1px solid rgb(0, 195, 255);
        transition: border 0.5s;
    }
`;

const Button = styled.button`
    padding: 15px;
    background: rgb(0, 195, 255);
    border: none;
    color: white;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.5s ease;

    &:hover {
        background: #0003;
    }
`;

const VideoWrapper = styled.div`
    div {
        display: flex;
        gap: 28px;

        @media (max-width: 768px) {
            flex-direction: column;
        }
    }

    iframe {
        border-radius: 10px;
    }

    h3 {
        margin-bottom: 10px;
        color: rgb(0, 195, 255);
    }
`;
